const loading = state => state.notifications.loading;
const error = state => state.notifications.error;
const notifications = state =>
  state.notifications.notifications ? state.notifications.notifications : {};

export default {
  loading,
  error,
  notifications
};
